import { MyProfileStateCardData } from "@components/molecules/MyProfileStateCard/MyProfileStateCard.data";
import { MyProfileCardType } from "@enums/my-profile-enums";

export interface MyProfileStatesData {
  cards: MyProfileStateCardData[];
}

export interface ServiceStateConfig {
  stage: string;
  icon?: string;
  altText: string;
  getIcon?: (data: any) => string
  getTitle: (data: any) => string;
  getSubtitle: (data: any) => string;
  getClickHandler: (stage: string, data: any) => { segmentStageName: string; regNo?: string };
  isScrollable?: boolean;
  isMultiple?: boolean;
}

export const SERVICE_STATE_CONFIG: ServiceStateConfig[] = [
  {
    stage: "next_service_date",
    getIcon: (data: any) => data.date_difference > 0 ? "/icons/hp_next_service_date.svg" : "/icons/hp_service_overdue.svg",
    altText: "Service due Icon",
    getTitle: (data?: any) => data.car_no,
    getSubtitle: (data?: any) => `Service ${data.date_difference > 0 ? `due in ${data.date_difference} days` : "overdue"}. Get exclusive offer with every service`,
    getClickHandler: (stage: string, data: any) => ({ segmentStageName: "Service due", regNo: data.car_no }),
    isScrollable: true,
    isMultiple: true
  },
  {
    stage: "upcoming_service",
    icon: "/icons/hp_upcoming_service.svg",
    altText: "Upcoming service Icon",
    getTitle: (data?: any) => `Upcoming service ${data?.vehicle_details?.registration_number ? `- ${data?.vehicle_details?.registration_number}` : ''}`,
    getSubtitle: (data?: any) => data?.booking_details?.appointment_date ? data.booking_details.appointment_date : '',
    getClickHandler: (stage: string, data: any) => ({ segmentStageName: "Upcoming service" }),
    isScrollable: false,
    isMultiple: false
  },
  {
    stage: "ongoing_service",
    icon: "/icons/hp_ongoing_service.svg",
    altText: "Ongoing service Icon",
    getTitle: (data?: any) => data.vehicle_details.registration_number,
    getSubtitle: (data?: any) => "On going service, track your vehicle repair",
    getClickHandler: (stage: string, data: any) => ({ segmentStageName: "Ongoing service" }),
    isScrollable: false,
    isMultiple: false
  }
];

export const myProfileStatesData: MyProfileStatesData = {
  cards: [
    {
      type: MyProfileCardType.EXPLORE,
      icon: "/icons/Explore_save_buy.svg",
      title: "Explore, save, and buy anytime",
      subText: [
        { text: "", color: "green300" },
        { text: " in your car savings wallet" },
      ],
      subTextNoBalance: [
        { text: "Additional discounts", color: "purple59" },
        { text: " if you avail car finance or car exchange" },
      ],
      introTextBold: "Made your choice?",
      introText: "We'll help you bring your dream car home",
      ctaIconName: "Arrow_right",
      additionalCtaText: "Ask Sid",
      backgroundBlur1: "vector_114_pink_blur",
      backgroundBlur2: "vector_113_blue_blur",
    },
    {
      type: MyProfileCardType.SERVICE,
      icon: "/icons/car_service.svg",
      title: "Car service with free pickup and drop",
      subText: [
        { text: "Track service live", color: "purple59" },
        { text: " from ACKO Drive garages" },
      ],
      ctaIconName: "Arrow_right",
      backgroundBlur1: "vector_114_pink_blur",
      backgroundBlur2: "vector_113_blue_blur",
    },
    {
      type: MyProfileCardType.VALUATION,
      icon: "/icons/sell_exchange.svg",
      title: "Sell or exchange for best value",
      subText: [
        { text: "Free valuation report " },
        { text: "every 3 months", color: "purple59" },
      ],
      ctaIconName: "Arrow_right",
      valuationReport: {
        regNumber: "KA 05 ND 5678",
        reportStatus: "Your Car Valuation report for March '25 is ready!",
        iconName: "Car_valuation_icon",
      },
      backgroundBlur1: "vector_114_pink_blur",
      backgroundBlur2: "vector_113_blue_blur",
    },
  ],
};
